import { createContext, type ReactNode, useContext, useMemo } from "react";


interface TemplatesEditorSettingsContextType {
  devMode: boolean;
  localEmailsTestingUrl: string;
  openThemeSettings?: () => void;
  currentUserEmail?: string;
}


const TemplatesEditorSettingsContext = createContext<
  TemplatesEditorSettingsContextType | undefined
>(undefined);


export interface TemplatesEditorSettingsProviderProps {
  devMode: boolean;
  localEmailsTestingUrl: string;
  children: ReactNode;
  openThemeSettings?: () => void;
  currentUserEmail?: string;
}


export function TemplatesEditorSettingsProvider({
  children,
  devMode,
  localEmailsTestingUrl,
  openThemeSettings,
  currentUserEmail,
}: TemplatesEditorSettingsProviderProps) {
  const value: TemplatesEditorSettingsContextType = useMemo(
    () => ({
      devMode,
      localEmailsTestingUrl,
      openThemeSettings,
      currentUserEmail,
    }),
    [devMode, localEmailsTestingUrl, openThemeSettings, currentUserEmail],
  );

  return (
    <TemplatesEditorSettingsContext.Provider value={value}>
      {children}
    </TemplatesEditorSettingsContext.Provider>
  );
}


export function useTemplatesEditorSettings() {
  const context = useContext(TemplatesEditorSettingsContext);

  if (context === undefined) {
    throw new Error(
      "useTemplatesEditorSettings must be used within a TemplatesEditorSettingsProvider",
    );
  }
  return context;
}
